// Tracks how often each IFS sender address is used (per IFS account, per browser)
// so the Create Shipment wizard can sort most-used senders first.
// v2: counters only increment when a shipment is actually created (not on card select).
// The prefix bump + purge below resets counters accumulated by the old behavior.
const KEY_PREFIX = 'ifs.senderUsage.v2.';
try {
    Object.keys(localStorage)
        .filter(k => k.startsWith('ifs.senderUsage.') && !k.startsWith(KEY_PREFIX))
        .forEach(k => localStorage.removeItem(k));
}
catch { /* ignore */ }
function read(accountId) {
    try {
        return JSON.parse(localStorage.getItem(KEY_PREFIX + accountId) || '{}');
    }
    catch {
        return {};
    }
}
export function recordSenderUse(accountId, addressId) {
    if (!accountId || !addressId)
        return;
    try {
        const usage = read(accountId);
        usage[addressId] = (usage[addressId] || 0) + 1;
        localStorage.setItem(KEY_PREFIX + accountId, JSON.stringify(usage));
    }
    catch { /* best-effort */ }
}
export function getSenderUsage(accountId) {
    if (!accountId)
        return {};
    return read(accountId);
}
